import CloudinaryImage from '@/components/CloudinaryImage'
import { ARCADE_CLOUDINARY_PATH } from '../../constants'
import useBreakpoints from '@/hooks/useBreakpoints'
import { ButtonLink } from '@/components/Button'
import { MergedSeason } from '../../types'

type Props = {
  season: MergedSeason
}
const ArcadeSeasonResultsIn = ({ season }: Props) => {
  const { isMobile } = useBreakpoints()
  const imgPath = isMobile ? 'resultsIn-mobile' : 'resultsIn'

  const dynamicTitle = `Season ${season.id}`

  return (
    // Top padding so box shadow doesn't get cut off by parent div that has overflow hidden
    <div className="container max-w-[1024px] pt-1">
      <div
        className="flex flex-col md:flex-row px-4 pt-4 md:px-0 md:pt-0 items-center gap-4 rounded-[32px] bg-arcadeShadowBg border-1 border-arcadeGreen md:pr-8 md:pl-4"
        style={{ boxShadow: '0px 0px 12px 0px rgba(110, 251, 84, 0.64)' }}
      >
        <div className="md:self-baseline order-1 md:order-0 flex items-end md:pt-[12px]">
          <CloudinaryImage
            imageId={imgPath}
            path={ARCADE_CLOUDINARY_PATH}
            layout="intrinsic"
            width={isMobile ? 179 : 148}
            height={isMobile ? 187 : 174}
          />
        </div>
        <div className="flex flex-col items-center gap-2 md:flex-row justify-between w-full order-0 md:order-1">
          <div className="flex flex-col gap-1 text-center md:text-left">
            <h4 className="h4">
              <span className="text-arcadeGreen block md:inline">
                {dynamicTitle}
              </span>{' '}
              Results are In!
            </h4>
            <p className="text-gray-300 body-lg">
              Check out where everyone ranked during season {season.id}.
            </p>
          </div>
          <div>
            <ButtonLink
              href={`/arcade/leaderboard?season=${season.id}`}
              theme="green-arcade"
            >
              View Season {season.id} Results
            </ButtonLink>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ArcadeSeasonResultsIn
